// Central index for all searchable content in the app
// This allows for quick full-text search across the entire application

export const searchIndex = [
  // TOOLS
  {
    id: 'osint',
    name: 'OSINT Quick Ref',
    type: 'command',
    category: 'Recon',
    difficulty: 'beginner',
    description: 'Open Source Intelligence gathering - perfect for beginners',
    tags: ['reconnaissance', 'information gathering', 'osint', 'passive recon'],
    path: '/tools',
  },
  {
    id: 'nmap',
    name: 'Nmap',
    type: 'command',
    category: 'Network',
    difficulty: 'beginner',
    description: 'Port scanner - essential for network mapping and service enumeration',
    tags: ['nmap', 'port scanning', 'network', 'enumeration', 'service detection'],
    path: '/tools',
  },
  {
    id: 'netcat',
    name: 'Netcat',
    type: 'command',
    category: 'Network',
    difficulty: 'beginner',
    description: 'Swiss-army knife for TCP/UDP - great for learning network fundamentals',
    tags: ['netcat', 'tcp', 'udp', 'reverse shell', 'bind shell', 'networking'],
    path: '/tools',
  },
  {
    id: 'hashid',
    name: 'Hash Identifier',
    type: 'command',
    category: 'Password',
    difficulty: 'beginner',
    description: 'Identify hash types - first step in password cracking',
    tags: ['hash', 'identification', 'hash types', 'password cracking'],
    path: '/tools',
  },
  {
    id: 'wireshark',
    name: 'Wireshark',
    type: 'command',
    category: 'Network',
    difficulty: 'intermediate',
    description: 'Network packet analyzer - understand traffic flows and protocol behavior',
    tags: ['wireshark', 'packet', 'network', 'sniffer', 'traffic analysis'],
    path: '/tools',
  },
  {
    id: 'burp',
    name: 'Burp Suite',
    type: 'command',
    category: 'Web Security',
    difficulty: 'intermediate',
    description: 'Web application testing framework with proxy and scanner',
    tags: ['burp suite', 'web app', 'proxy', 'vulnerability', 'testing'],
    path: '/tools',
  },
  {
    id: 'sqlmap',
    name: 'SQLmap',
    type: 'command',
    category: 'Web Security',
    difficulty: 'beginner',
    description: 'SQL injection automation-test and extract databases',
    tags: ['sqlmap', 'sql injection', 'database', 'injection', 'web security'],
    path: '/tools',
  },
  {
    id: 'hydra',
    name: 'Hydra',
    type: 'command',
    category: 'Password',
    difficulty: 'intermediate',
    description: 'Parallel login brute-forcer - test default credentials and weak passwords',
    tags: ['hydra', 'brute force', 'password', 'login', 'credential'],
    path: '/tools',
  },
  {
    id: 'john',
    name: 'John the Ripper',
    type: 'command',
    category: 'Password',
    difficulty: 'intermediate',
    description: 'Password cracking tool - optimize with custom rules and wordlists',
    tags: ['john', 'password cracking', 'hash cracking', 'wordlist'],
    path: '/tools',
  },
  {
    id: 'hashcat',
    name: 'Hashcat',
    type: 'command',
    category: 'Password',
    difficulty: 'advanced',
    description: 'Fast multi-algorithm password cracker with GPU acceleration',
    tags: ['hashcat', 'password', 'gpu', 'cracking', 'hash'],
    path: '/tools',
  },
  {
    id: 'metasploit',
    name: 'Metasploit',
    type: 'command',
    category: 'Exploitation',
    difficulty: 'intermediate',
    description: 'Penetration testing framework - leverage exploits and payloads',
    tags: ['metasploit', 'exploitation', 'payload', 'framework', 'msfconsole'],
    path: '/tools',
  },
  {
    id: 'powershell',
    name: 'PowerShell',
    type: 'command',
    category: 'Windows',
    difficulty: 'intermediate',
    description: 'Windows scripting - execute commands and build automation',
    tags: ['powershell', 'windows', 'scripting', 'cmd', 'command'],
    path: '/tools',
  },
  {
    id: 'enum4linux',
    name: 'Enum4linux',
    type: 'command',
    category: 'Windows',
    difficulty: 'beginner',
    description: 'Windows/Samba enumeration-gather user and share information',
    tags: ['enum4linux', 'smb', 'samba', 'enumeration', 'windows'],
    path: '/tools',
  },
  {
    id: 'ir',
    name: 'IR Checklist',
    type: 'command',
    category: 'Incident Response',
    difficulty: 'intermediate',
    description: 'Structured incident response checklist for systematic investigation',
    tags: ['incident response', 'ir', 'checklist', 'forensics', 'investigation'],
    path: '/tools',
  },

  // CHEAT SHEETS
  {
    id: 'linux-privesc',
    name: 'Linux PrivEsc',
    type: 'cheatsheet',
    category: 'Privilege Escalation',
    difficulty: 'beginner',
    description: 'Master privilege escalation on Linux systems - 25+ techniques',
    tags: ['privilege escalation', 'linux', 'privesc', 'suid', 'sudo', 'capabilities'],
    path: '/cheatsheets',
  },
  {
    id: 'windows-privesc',
    name: 'Windows PrivEsc',
    type: 'cheatsheet',
    category: 'Privilege Escalation',
    difficulty: 'intermediate',
    description: 'Escalate privileges on Windows - UAC bypass, token impersonation, and more',
    tags: ['privilege escalation', 'windows', 'privesc', 'uac', 'token', 'juicy potato'],
    path: '/cheatsheets',
  },
  {
    id: 'web-app-testing',
    name: 'Web App Testing',
    type: 'cheatsheet',
    category: 'Web Security',
    difficulty: 'beginner',
    description: 'Complete web application penetration testing framework',
    tags: ['web', 'application', 'testing', 'owasp', 'vulnerability', 'pentest'],
    path: '/cheatsheets',
  },
  {
    id: 'active-directory',
    name: 'Active Directory Attacks',
    type: 'cheatsheet',
    category: 'Enterprise Security',
    difficulty: 'intermediate',
    description: 'Advanced AD enumeration and exploitation - Kerberoasting, path finding',
    tags: ['active directory', 'ad', 'kerberos', 'bloodhound', 'domain admin'],
    path: '/cheatsheets',
  },
  {
    id: 'initial-access',
    name: 'Initial Access Techniques',
    type: 'cheatsheet',
    category: 'Attack Techniques',
    difficulty: 'intermediate',
    description: 'Multiple paths to initial compromise and entry',
    tags: ['initial access', 'phishing', 'exploit', 'compromise', 'entry'],
    path: '/cheatsheets',
  },
  {
    id: 'payload-gen',
    name: 'Payload Generation',
    type: 'cheatsheet',
    category: 'Exploitation',
    difficulty: 'intermediate',
    description: 'Create custom payloads for various scenarios and architectures',
    tags: ['payload', 'generation', 'shellcode', 'msfvenom', 'binary'],
    path: '/cheatsheets',
  },
  {
    id: 'c2-frameworks',
    name: 'C2 Frameworks',
    type: 'cheatsheet',
    category: 'Post-Exploitation',
    difficulty: 'advanced',
    description: 'Command and control frameworks - Cobalt Strike, Empire, and alternatives',
    tags: ['c2', 'command and control', 'cobalt strike', 'empire', 'post-ex'],
    path: '/cheatsheets',
  },
  {
    id: 'post-exploitation',
    name: 'Post-Exploitation',
    type: 'cheatsheet',
    category: 'Post-Exploitation',
    difficulty: 'advanced',
    description: 'Persistence, lateral movement, and data exfiltration techniques',
    tags: ['post-exploitation', 'persistence', 'lateral movement', 'exfiltration'],
    path: '/cheatsheets',
  },
  {
    id: 'cloud-pentesting',
    name: 'Cloud Pentesting',
    type: 'cheatsheet',
    category: 'Cloud Security',
    difficulty: 'advanced',
    description: 'AWS, Azure, and GCP security testing methodologies',
    tags: ['cloud', 'aws', 'azure', 'gcp', 'security', 'penetration testing'],
    path: '/cheatsheets',
  },

  // UTILITY TOOLS
  {
    id: 'base64-encoder',
    name: 'Base64 Encoder/Decoder',
    type: 'utility',
    category: 'Encoding',
    difficulty: 'beginner',
    description: 'Encode and decode Base64 - essential for payload obfuscation',
    tags: ['base64', 'encode', 'decode', 'obfuscation', 'payload'],
    path: '/utilities',
  },
  {
    id: 'url-encoder',
    name: 'URL Encoder/Decoder',
    type: 'utility',
    category: 'Encoding',
    difficulty: 'beginner',
    description: 'URL encode/decode - format payloads for HTTP requests',
    tags: ['url', 'encode', 'decode', 'percent encoding', 'http'],
    path: '/utilities',
  },
  {
    id: 'hex-converter',
    name: 'Hex Converter',
    type: 'utility',
    category: 'Encoding',
    difficulty: 'beginner',
    description: 'Convert between hex, text, and binary formats',
    tags: ['hex', 'binary', 'conversion', 'encoding', 'bytes'],
    path: '/utilities',
  },
  {
    id: 'reverse-shell',
    name: 'Reverse Shell Generator',
    type: 'utility',
    category: 'Payloads',
    difficulty: 'intermediate',
    description: 'Generate reverse shell payloads for bash, PowerShell, Python, and more',
    tags: ['reverse shell', 'shell', 'payload', 'bash', 'powershell', 'python'],
    path: '/utilities',
  },
  {
    id: 'regex-tester',
    name: 'Regex Tester',
    type: 'utility',
    category: 'Tools',
    difficulty: 'intermediate',
    description: 'Test and validate regex patterns with instant feedback',
    tags: ['regex', 'regular expression', 'pattern', 'matching', 'validation'],
    path: '/utilities',
  },
  {
    id: 'json-formatter',
    name: 'JSON Formatter',
    type: 'utility',
    category: 'Formatting',
    difficulty: 'beginner',
    description: 'Format, validate, and minify JSON data',
    tags: ['json', 'format', 'validate', 'minify', 'prettify'],
    path: '/utilities',
  },
];

// Categories for filtering
export const categories = [
  'Recon',
  'Network',
  'Web Security',
  'Password',
  'Exploitation',
  'Post-Exploitation',
  'Privilege Escalation',
  'Enterprise Security',
  'Attack Techniques',
  'Cloud Security',
  'Windows',
  'Incident Response',
  'Encoding',
  'Payloads',
  'Formatting',
  'Tools',
];

// Difficulties for filtering
export const difficulties = [
  'beginner',
  'intermediate',
  'advanced',
];

// Types for filtering
export const types = [
  { value: 'command', label: 'Command Tools' },
  { value: 'cheatsheet', label: 'Cheat Sheets' },
  { value: 'utility', label: 'Utilities' },
];
